import { observer } from 'mobx-react-lite';
import React from 'react';
import { getPercentage } from '../../../../stores/utils';
import { ItemTitle, ListItemSummary, SVGCircle } from '../../index';
import { SmallChart } from '../Styles';

const formatCommas = (value) => new Intl.NumberFormat().format(value);

export const TotalProductsStatused = observer(
  ({
    auctionID,
    itemName,
    productNonStatusedCount,
    productStatusedCount,
    productTotalCount,
  }) => {
    const pct = getPercentage(productStatusedCount, productTotalCount);
    const showRedChart = pct < 100 && pct > 95;
    return (
      <>
        <ItemTitle
          testId="products-statused--label"
          textSize={1.1}
          titleText="Total Products Statused:"
        />
        <SmallChart style={{ marginTop: '-30px' }}>
          <SVGCircle
            auctionID={auctionID}
            auctionName={itemName}
            chartError={showRedChart}
            clickRoute={`/auction/${auctionID}/products/`}
            key={`svg-products-status-${productNonStatusedCount}`}
            percentvalue={pct}
            popupHeader="Products Statused"
            popupPosition="right center"
            testId={`total-products-statused-${auctionID}`}
            text={`${
              formatCommas(productStatusedCount) +
              '/' +
              formatCommas(productTotalCount)
            }`}
          />
        </SmallChart>
      </>
    );
  },
);

export default TotalProductsStatused;
